import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for deleting a marker
 */
export interface DeleteMarkerVariables {
  markerId: string;
}

/**
 * Delete marker mutation response payload
 */
export interface DeleteMarkerPayload {
  success: boolean;
}

/**
 * Response structure for deleteMarker mutation
 */
export interface DeleteMarkerResponse {
  deleteMarker: DeleteMarkerPayload;
}

const deleteMarker: DocumentNode = gql`
  mutation deleteMarker($markerId: ID!) {
    deleteMarker(markerId: $markerId) {
      success
    }
  }
`;

export default deleteMarker;
